import {UserLocalDataModel} from '../user-local-data.model';
import {TCommonModel} from '../common/t-common-model';
import {AutoMap} from '@automapper/classes';
import {FormField} from '../../../core/decorators/form-field.decorator';
import {FormGroup, ValidatorFn, Validators} from '@angular/forms';

export class SignUpRequestModel extends TCommonModel {
  @FormField({
    default: '',
    validators: [Validators.required, Validators.maxLength(70)]
  })
  @AutoMap()
  firstName!: string;

  @FormField({
    default: '',
    validators: [Validators.maxLength(80)]
  })
  @AutoMap()
  lastName!: string;

  @FormField({
    default: '',
    readonly: true,
    validators: [Validators.required, Validators.email]
  })
  @AutoMap()
  email!: string;

  @FormField({
    default: '',
    hidden: true,
    validators: [Validators.required]
  })
  @AutoMap()
  verificationCode!: string;
}

export class SignUpResponseModel extends UserLocalDataModel {

}
